<div class="flex flex-column h-full overflow-hidden">
    <div class="flex justify-content-between border-bottom-1 surface-border align-items-center px-4 py-3">
        <p class="h5 font-bold">{{ 'default-cm-groups' | translate: 'Groups' }}</p>
        <p-button
            styleClass="gap-12"
            icon="pi pi-plus"
            label="{{ 'default-cm-addGroup' | translate: 'Add Group' }}"
            (onClick)="navigateToCreateGroup()"
        ></p-button>
    </div>

    <div class="flex justify-content-between align-items-center w-full border-bottom-1 surface-border">
        <app-pagination-bar
            class="w-full"
            (filtersChange)="paginationChange($event)"
            (pageSizeChange)="changePageSize($event)"
            [(filters)]="filter"
            (filtersSearch)="searchGroup()"
        ></app-pagination-bar>
    </div>

    <!-- table starting -->
    <div class="overflow-auto h-full">
        <p-table
            styleClass="alpha-border-1 border-x-none border-y-none"
            [value]="currentGroups"
            [scrollable]="true"
            scrollHeight="flex"
        >
            <!-- table header start -->
            <ng-template pTemplate="header">
                <tr class="text-sm">
                    <th class="col-3">
                        <div class="relative inline pr-4">
                            {{ 'default-cm-groupName' | translate: 'Group Name' }}
                            <span (click)="customSort('group_name')" class="absolute right-0 top-0 pr-1 cursor-pointer">
                                @if (!sort['group_name']) {
                                    <img class="ml-2" src="assets/icons/sort-icon.svg" alt="sort" />
                                }
                                @if (sort['group_name'] && sortStatus === 'asc') {
                                    <img src="assets/icons/sort-asc-icon.svg" alt="sort" />
                                }
                                @if (sort['group_name'] && sortStatus === 'desc') {
                                    <img src="assets/icons/sort-desc-icon.svg" alt="sort" />
                                }
                            </span>
                        </div>
                    </th>
                    <th class="col-4">
                        <div class="relative inline pr-4">
                            {{ 'default-cm-description' | translate: 'Description' }}
                            <span
                                (click)="customSort('description')"
                                class="absolute right-0 top-0 pr-1 cursor-pointer"
                            >
                                @if (!sort['description']) {
                                    <img src="assets/icons/sort-icon.svg" alt="sort" />
                                }
                                @if (sort['description'] && sortStatus === 'asc') {
                                    <img src="assets/icons/sort-asc-icon.svg" alt="sort" />
                                }
                                @if (sort['description'] && sortStatus === 'desc') {
                                    <img src="assets/icons/sort-desc-icon.svg" alt="sort" />
                                }
                            </span>
                        </div>
                    </th>
                    <th class="col-1">
                        <div class="relative inline pr-4">
                            {{ 'default-cm-users' | translate: 'Users' }}
                            <span
                                (click)="customSort('number_of_users')"
                                class="absolute right-0 top-0 pr-1 cursor-pointer"
                            >
                                @if (!sort['number_of_users']) {
                                    <img src="assets/icons/sort-icon.svg" alt="sort" />
                                }
                                @if (sort['number_of_users'] && sortStatus === 'asc') {
                                    <img src="assets/icons/sort-asc-icon.svg" alt="sort" />
                                }
                                @if (sort['number_of_users'] && sortStatus === 'desc') {
                                    <img src="assets/icons/sort-desc-icon.svg" alt="sort" />
                                }
                            </span>
                        </div>
                    </th>
                    <th class="col-3">
                        <div class="relative inline pr-4">
                            {{ 'default-cm-updatedOn' | translate: 'Updated On' }}
                            <span (click)="customSort('updatedAt')" class="absolute right-0 top-0 pr-1 cursor-pointer">
                                @if (!sort['updatedAt']) {
                                    <img src="assets/icons/sort-icon.svg" alt="sort" />
                                }
                                @if (sort['updatedAt'] && sortStatus === 'asc') {
                                    <img src="assets/icons/sort-asc-icon.svg" alt="sort" />
                                }
                                @if (sort['updatedAt'] && sortStatus === 'desc') {
                                    <img src="assets/icons/sort-desc-icon.svg" alt="sort" />
                                }
                            </span>
                        </div>
                    </th>
                    <th class="col-1">{{ 'default-cm-action' | translate: 'Action' }}</th>
                </tr>
            </ng-template>
            <!-- table header end -->

            <!-- table body start -->
            <ng-template pTemplate="body" let-group>
                <tr class="text-normal text-md">
                    <td class="col-3">
                        <span
                            class="block overflow-hidden text-overflow-ellipsis white-space-nowrap max-w-20rem"
                            pTooltip="{{ group.group_name }}"
                            tooltipPosition="bottom"
                            >{{ group.group_name }}</span
                        >
                    </td>
                    <td class="col-4">
                        <span
                            class="block overflow-hidden text-overflow-ellipsis white-space-nowrap max-w-20rem"
                            pTooltip="{{ group.description }}"
                            tooltipPosition="bottom"
                            >{{ group.description }}</span
                        >
                    </td>
                    <td class="col-1 cursor-pointer hover:text-primary-700" (click)="handleBulkClick(group.group_name)">
                        {{ group.number_of_users }}
                    </td>
                    <td class="col-3 white-space-nowrap">{{ group.updatedAt | date: 'medium' }}</td>
                    <td class="col-1">
                        @if (group.group_name !== admin_group) {
                            <span
                                (click)="openToggleMenu(action, group, $event)"
                                class="flex align-items-center justify-content-start border-round-sm p-1 width-20 padding-py-10 hover:bg-white hover:text-primary-700"
                            >
                                <i class="pi pi-ellipsis-v w-full h-full"></i>
                            </span>
                        }
                    </td>
                </tr>
            </ng-template>
            <!-- table body end -->
        </p-table>
    </div>
</div>

<p-menu
    #action
    [model]="menuOptions"
    [popup]="true"
    styleClass="w-8rem p-0 cursor-pointer hover:surface-hover shadow-md"
>
    <ng-template pTemplate="item" let-action>
        <div class="flex w-2rem cursor-pointer gap-1 align-items-center py-3 px-3">
            <img [src]="action.icon" height="15" alt="-" />
            <span class="font-normal line-height-1">{{ action.label | translate }}</span>
        </div>
    </ng-template>
</p-menu>

<platform-list-drawer
    position="right"
    [visible]="userVisible"
    [filteredUsers]="filteredUsers"
    (filterUsers)="filterUsers($event)"
    (visibleChange)="visibleChange($event)"
    header="default-cm-usersByGroup"
></platform-list-drawer>
